import React from 'react';
import { withApollo } from '@apollo/client/react/hoc';
import { Field } from 'formik';

import EmployerBlacklistQuery from 'buyside/graphql/queries/EmployerBlacklist';
import EmployerSearchQuery from 'buyside/graphql/queries/EmployerSearch';

import AutocompleteField from 'buyside/components/presentation/Form/Field/AutocompleteField/autocompleteField';

export class WorkExperienceAutocomplete extends React.Component {
  constructor() {
    super();
    this.state = { loading: false, query: '', suggestions: [] };
    this.selectIntercept = this.selectIntercept.bind(this);
    this.changeIntercept = this.changeIntercept.bind(this);
  }

  componentDidMount() {
    this.props.client.query({ query: EmployerBlacklistQuery }).then(res => {
      this.employerBlacklist = res.data.employerBlacklist;
    });
  }

  selectIntercept(value, selectedItem) {
    const { name, setFieldValue } = this.props;
    setFieldValue(
      name + '.employer.isFake',
      this.employerBlacklist
        .map(item => item.toLowerCase())
        .includes(selectedItem.name.toLowerCase())
    );
    setFieldValue(name + '.employer.name', selectedItem.name);
    if (selectedItem.aumRange !== 'N/A') {
      setFieldValue(name + '.employer.aumRange', selectedItem.aumRange);
    }
    setFieldValue(name + '.employer.fundType', selectedItem.fundType);
  }

  changeIntercept(query) {
    this.setState({ loading: true, query });
    this.props.client.query({ query: EmployerSearchQuery, variables: { query } }).then(res => {
      const newEmployer = {
        displayName: `+ Add New Employer (${this.state.query})`,
        name: this.state.query
      };
      this.setState({
        loading: false,
        suggestions: [newEmployer].concat(res.data.employerSearch)
      });
    });
  }

  render() {
    const autosuggestOptions = {};
    return (
      <Field
        component={AutocompleteField}
        name={this.props.name + '.employer.name'}
        label="Employer Name"
        locked={this.props.locked}
        changeIntercept={this.changeIntercept}
        selectIntercept={this.selectIntercept}
        suggestions={this.state.suggestions}
        handleSuggestionsClearRequested={() => this.setState({ suggestions: [] })}
        formatSuggestion={suggestion => suggestion.displayName || suggestion.name}
        getSuggestionValue={suggestion => suggestion.name}
        isWide
        autosuggestOptions={autosuggestOptions}
        loading={this.state.loading}
        debounce
      />
    );
  }
}

export default withApollo(WorkExperienceAutocomplete);
